export enum IdentifierType {
    VatNumber = "VAT_NUMBER",
    TaxId = "TAX_ID",
    TsDigitaliId = "TS_DIGITAL_ID",
}

export enum PaymentPlanType {
    SingleInstallment = "SINGLE_INSTALLMENT",
    MultipleInstallments = "MULTIPLE_INSTALLMENTS",
}

export enum PaymentMethodName {
    TsPayBankTransfer = "TS_PAY_BANK_TRANSFER",
    TsPayInstantBankTransfer = "TS_PAY_INSTANT_BANK_TRANSFER",
    TsPayCreditCard = "TS_PAY_CREDIT_CARD",
    TsPayPayPal = "TS_PAY_PAYPAL",
    External = "EXTERNAL",
}

export enum PaymentRequestStatus {
    Paid = "PAID",
    ExternalPaid = "EXTERNAL_PAID",
    NotPaid = "NOT_PAID",
    Scheduled = "SCHEDULED",
}

export enum PaymentStatus {
    Paid = "PAID",
    ExternalPaid = "EXTERNAL_PAID",
    NotPaid = "NOT_PAID",
    NotYetPaid = "NOT_YET_PAID",
    OnHold = "ON_HOLD",
    Scheduled = "SCHEDULED",
}

export enum ConfirmedPaymentType {
    Link2Pay = "link2pay",
    Link2Save = "link2save",
}

export enum ConfirmedPaymentState {
    Active = "active",
    Pending = "pending",
    Failed = "failed",
}
